import PropTypes from 'prop-types';
import React from 'react';

import { mapMatchesToCompetitions } from 'modules/Football/utils';
import CollapsibleSection from 'modules/Common/components/CollapsibleSection';
import FootballMatchRoundList from './FootballMatchRoundList';
import {titleToId} from 'utils/url-rewrite';

require('./FootballLiveCompetitionList.scss');

export default function FootballLiveCompetitionList({ matchList = [] }) {

  const mappedCompetitionMatches = mapMatchesToCompetitions(matchList) || [];

  return (
    <ul>
      {
        mappedCompetitionMatches.map(({
          id,
          name,
          matchList = []
        }) => (
          <li key={id}>
            <div className="FootballMatchList" id={titleToId(name)}>
              <CollapsibleSection title={name}>
                <FootballMatchRoundList matchList={matchList}/>
              </CollapsibleSection>
            </div>
          </li>
        ))
      }
    </ul>
  );
}

FootballLiveCompetitionList.propTypes = {
  matchList: PropTypes.array.isRequired
};



// WEBPACK FOOTER //
// ./modules/Football/components/FootballLiveCompetitionList.js